import { getJson } from '../../../shared/api/httpClient';

export async function fetchCounterPoints({ userAccessToken, deviceAccessToken }) {
  const jsonResponse = await getJson('GetMarivalCountPoints', {
    UserAccessToken: userAccessToken,
    DeviceAccessToken: deviceAccessToken,
    RegisterType: 'Agent'
  });

  return {
    pointsAvailable: jsonResponse.PointsAvailable,
    pointsPending: jsonResponse.PointsPending
  };
}
